import store from "../../src/store";
import { DetectWC } from "../mixins/wcDetector";
import { DetectVersion } from "../mixins/versionDetector";
import { getStoreWithName } from "./services/storeService";
import $ from "jquery";
var isWC = DetectWC.methods.isWC();

export async function routerGuard(to, from, next) {
  if (
    isWC &&
    to.path == "/" &&
    from.path != "/" &&
    !store.getters.storeSelectionAtCheckoutMode
  ) {
    location.href = location.origin;
    return;
  }
  if (
    to.fullPath.indexOf("checkout") >= 0 &&
    store.getters.selectedCompany.ViewComponentConfigs.LogIn &&
    store.getters.selectedCompany.ViewComponentConfigs.LogInMandatory &&
    (!store.getters.dbuser ||
      (store.getters.selectedCompany.ViewComponentConfigs.SMSVerification &&
        !store.getters.dbuser.isVerified))
  ) {
    next({
      name: "store",
      params: {
        storeid: store.getters.selectedCompany.ID,
        storename: store.getters.selectedCompany.Name,
      },
    });
    return;
  }
  if (
    to.fullPath.indexOf("checkout") >= 0 ||
    to.fullPath.indexOf("shoppingcartmobile") >= 0 ||
    to.fullPath.indexOf("completeorder") >= 0
  ) {
    store.commit("setIsInCkeckout", true);
  }
  //reset distance
  else {
    store.dispatch("resetDistance");
    store.commit("setIsInCkeckout", false);
  }
  const bodyScrollLock = require("body-scroll-lock");
  bodyScrollLock.clearAllBodyScrollLocks();
  // verify version
  var currentVersion = localStorage.getItem("VERSION");
  var appVersion = DetectVersion.methods.VERSION();
  if (currentVersion != appVersion) {
    store.dispatch("clearCart");
    localStorage.setItem("VERSION", appVersion);
  }
  if (to.fullPath.indexOf("gift") != -1) store.commit("setIsGift", true);
  else store.commit("setIsGift", false);
  if (to.query.room) {
    localStorage.setItem("room", to.query.room);
  }
  if (to.query.table) {
    sessionStorage.setItem("table", to.query.table);
    sessionStorage.setItem("hideOtherOrderType", "true");
    if (to.query.s) {
      sessionStorage.setItem("securityCode", to.query.s);
    }
  } else {
    sessionStorage.removeItem("table");
    sessionStorage.removeItem("hideOtherOrderType");
  }
  if (to.query.coupon) {
    localStorage.setItem("coupon", to.query.coupon);
  }
  $("#uniquemodal").modal("hide");
  if (store.getters.getCartType) {
    store.dispatch("clearCardType", null);
  }

  if (from.query.mobile) {
    to.query.mobile = from.query.mobile;
  }
  sessionStorage.setItem("isMobile", to.query.mobile);

  //detect refresh
  if (to.params.storename && !to.params.storeid) {
    store.commit("setPopularStatus", true);
    if (isNumeric(to.params.storename)) to.params.storeid = to.params.storename;
    else if (from.params.storename == to.params.storename) {
      if (from.params.storeid) to.params.storeid = from.params.storeid;
      else to.params.storeid = store.getters.currentstore.ID;
    } else {
      var storeDoc = await getStoreWithName(to.params.storename).get();
      if (storeDoc.size > 0) {
        to.params.storeid = storeDoc.docs[0].data().ID;
        store.dispatch("initStore", storeDoc.docs[0].data().ID);
        store.dispatch("selectSubCompany");
      } else {
        next({
          name: "notFoundPage",
        });
      }
    }
  }
  if (to.params.storeid) {
    window.onload = function () {
      if (to.params.storeid) {
        store.dispatch("initStore", to.params.storeid);
        store.dispatch("selectSubCompany");
      }
    };
  }
  //prevent intro page for none hq stores
  if (isWC) {
    var ooConfig = JSON.parse(sessionStorage.getItem("OOConfig"));
    if (ooConfig) {
      if (ooConfig.IsGift) {
        if (to.name == "mainpage") {
          next({
            name: "giftstore",
            params: {
              storeid: ooConfig.ID,
              storename: ooConfig.Name,
            },
          });
          return false;
        }
      }
      if (ooConfig.IsHQ == false) {
        if (to.name == "mainpage") {
          next({
            name: "store",
            params: {
              storeid: ooConfig.ID,
              storename: ooConfig.Name,
            },
          });
          return false;
        }
        //lock specefied store
        if (to.params.storeid) {
          if (to.params.storeid != ooConfig.ID) {
            var prms = to.params;
            prms.storeid = ooConfig.ID;
            next({ name: to.name, params: prms });
            return false;
          }
        }
      } else {
        storeChange(to, next);
      }
    }
  }
  storeChange(to, next);
}
function storeChange(to, next) {
  if (to.params.storeid) {
    store.dispatch("initPriceTriggers", to.params.storeid);
    //store.dispatch("initMessageTemplates", to.params.storeid);
  }

  if (
    to.params.storeid &&
    store.getters.currentstore &&
    to.params.storeid != store.getters.currentstore &&
    store.getters.cartItems.length > 0
  ) {
    if (!store.getters.storeSelectionAtCheckoutMode) {
      store.commit("AddCartItemsToRepository", {
        storeId: store.getters.currentstore,
        cartItems: store.getters.cartItems,
      });
      store.dispatch("clearCart");
      store.dispatch("clearStoreMenu");
      store.dispatch("loadCartItemsFromRepository", to.params.storeid);
      next();
    } else {
      next();
    }
  } else {
    if (store.getters.cartItems.length == 0) {
      store.dispatch("loadCartItemsFromRepository", to.params.storeid);
    }
    next();
  }
}
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}
